<script lang="ts">
	import { onMount } from 'svelte';

	import { interests as interestStore } from '../../stores';
	import InterestPicker from './InterestPicker.svelte';
	import Button, { Label } from '@smui/button/styled';
	import { Icon } from '@smui/fab/styled';
	import type { Interest } from 'Segments';

	export let data: Interest[];

	let selectedInterest2 = '';
	let selectedInterest1 = '';
	let isPickedGenInterest1 = false;
	let isPickedGenInterest2 = false;
	let chosenColumnToSort = '';
	let sort = ['desc', 'desc', 'desc', 'desc'];
	let firstXElementsCount = 500;
	let restToLoad = 0;

	let arrayOfVisibleData = data;

	$: arrayOfVisibleDataWithFirstXElements = arrayOfVisibleData.slice(0, firstXElementsCount);
	$: {
		if (arrayOfVisibleData.length - arrayOfVisibleDataWithFirstXElements.length > 500) {
			restToLoad = 500;
		} else {
			restToLoad = arrayOfVisibleData.length - arrayOfVisibleDataWithFirstXElements.length;
		}
	}

	const formatInterestOverlapData = () => {
		for (let i = 0; i < data.length; i++) {
			data[i].overlap = parseFloat(data[i].overlap).toFixed(2);
			data[i].relevance = parseFloat(data[i].relevance).toFixed(2);
		}
	};

	onMount(() => {
		formatInterestOverlapData();
	});

	function handlePickerSelect(event: CustomEvent) {
		firstXElementsCount = 500;
		if (event.detail.selectId === 1) {
			selectedInterest1 = event.detail.value;
			isPickedGenInterest1 = event.detail.isGeneralInterest;
		}
		if (event.detail.selectId === 2) {
			selectedInterest2 = event.detail.value;
			isPickedGenInterest2 = event.detail.isGeneralInterest;
		}
		filterData(selectedInterest1, selectedInterest2, isPickedGenInterest1, isPickedGenInterest2);
	}

	function filterData(
		interest1: string,
		interest2: string,
		isGenInterest1: boolean,
		isGenInterest2: boolean
	) {
		arrayOfVisibleData = [];
		chosenColumnToSort = '';
		sort = ['desc', 'desc', 'desc', 'desc'];
		for (let i = 0; i < data.length; i++) {
			if (!isGenInterest1 && !isGenInterest2) {
				if (
					(interest1 === '' || interest1 === 'All' || data[i].interest1 === interest1) &&
					(interest2 === '' || interest2 === 'All' || data[i].interest2 === interest2)
				) {
					arrayOfVisibleData.push(data[i]);
				}
			} else if (isGenInterest1 && isGenInterest2) {
				if (
					data[i].interest1.toUpperCase() === interest1 &&
					data[i].interest2.toUpperCase() === interest2
				) {
					arrayOfVisibleData.push(data[i]);
				}
				if (data[i].generalInterest1 === null && data[i].generalInterest2 !== null) {
					if (
						data[i].interest1.toUpperCase() === interest1 &&
						data[i].generalInterest2.toUpperCase() === interest2
					) {
						arrayOfVisibleData.push(data[i]);
					}
				}
				if (data[i].generalInterest1 !== null && data[i].generalInterest2 === null) {
					if (
						data[i].generalInterest1.toUpperCase() === interest1 &&
						data[i].interest2.toUpperCase() === interest2
					) {
						arrayOfVisibleData.push(data[i]);
					}
				}
				if (data[i].generalInterest1 != null && data[i].generalInterest2 != null) {
					if (
						data[i].generalInterest1.toUpperCase() === interest1 &&
						data[i].generalInterest2.toUpperCase() === interest2
					) {
						arrayOfVisibleData.push(data[i]);
					}
				}
			} else if (isGenInterest2) {
				if (
					(interest1 === '' || interest1 === 'All' || data[i].interest1 === interest1) &&
					data[i].interest2.toUpperCase() === interest2
				) {
					arrayOfVisibleData.push(data[i]);
				}
				if (data[i].generalInterest2 != null) {
					if (
						(interest1 === '' || interest1 === 'All' || data[i].interest1 === interest1) &&
						data[i].generalInterest2.toUpperCase() === interest2
					) {
						arrayOfVisibleData.push(data[i]);
					}
				}
			} else if (isGenInterest1) {
				if (
					data[i].interest1.toUpperCase() === interest1 &&
					(interest2 === '' || interest2 === 'All' || data[i].interest2 === interest2)
				) {
					arrayOfVisibleData.push(data[i]);
				}
				if (data[i].generalInterest1 != null) {
					if (
						data[i].generalInterest1.toUpperCase() === interest1 &&
						(interest2 === '' || interest2 === 'All' || data[i].interest2 === interest2)
					) {
						arrayOfVisibleData.push(data[i]);
					}
				}
			}
		}
	}

	function handleSortButtonClick(columnNum: number, clickedColumnName: string) {
		firstXElementsCount = 500;
		if (chosenColumnToSort === clickedColumnName) {
			sort[columnNum] === 'desc' ? (sort[columnNum] = 'asc') : (sort[columnNum] = 'desc');
		} else {
			chosenColumnToSort = clickedColumnName;
		}
		for (let i = 0; i < 4; i++) {
			i === columnNum ? (sort[i] = sort[i]) : (sort[i] = 'desc');
		}
		handleSorting();
	}

	function handleSorting() {
		switch (chosenColumnToSort) {
			case 'interest1':
				sortByColumn(0, chosenColumnToSort, 'string');
				break;
			case 'interest2':
				sortByColumn(1, chosenColumnToSort, 'string');
				break;
			case 'overlap':
				sortByColumn(2, chosenColumnToSort, 'float');
				break;
			case 'relevance':
				sortByColumn(3, chosenColumnToSort, 'float');
				break;
		}
	}

	async function sortByColumn(columnNum: number, columnName: string, columnVarType: string) {
		let visibleArrayCopy = arrayOfVisibleData;
		arrayOfVisibleData = [];
		visibleArrayCopy = visibleArrayCopy.sort(function (a, b) {
			var compared_a = a[columnName],
				compared_b = b[columnName];
			if (columnVarType === 'float') {
				compared_a = parseFloat(compared_a);
				compared_b = parseFloat(compared_b);
			}
			if (columnVarType === 'string') {
				compared_a = compared_a.toLowerCase();
				compared_b = compared_b.toLowerCase();
			}
			if (sort[columnNum] === 'asc') {
				return compared_a > compared_b ? -1 : 1;
			} else {
				return compared_a < compared_b ? -1 : 1;
			}
		});
		arrayOfVisibleData = visibleArrayCopy;
	}

	function handlePaginating() {
		firstXElementsCount = firstXElementsCount + 500;
	}
</script>

<table>
	<tr>
		<th class="th-interest">
			<div class="interest-selector-th">
				<Button
					class="sort-button-interest myClass"
					variant={chosenColumnToSort === 'interest1' ? 'unelevated' : 'outlined'}
					on:click={() => {
						handleSortButtonClick(0, 'interest1');
					}}
				>
					<Icon class="material-icons"
						><p class="myicon">{sort[0] === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up'}</p></Icon
					>
				</Button>
				<InterestPicker
					id={1}
					on:message={handlePickerSelect}
					options={$interestStore.filter(() => {
						return true;
					})}
				/>
			</div>
		</th><th class="th-interest">
			<div class="interest-selector-th">
				<Button
					class="sort-button-interest"
					variant={chosenColumnToSort === 'interest2' ? 'unelevated' : 'outlined'}
					on:click={() => {
						handleSortButtonClick(1, 'interest2');
					}}
				>
					<Icon class="material-icons"
						><p class="myicon">{sort[1] === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up'}</p></Icon
					>
				</Button>
				<InterestPicker
					id={2}
					on:message={handlePickerSelect}
					options={$interestStore.filter(() => {
						return true;
					})}
				/>
			</div>
		</th>
		<th class="th-numbers">
			<Button
				class="sort-button-number"
				variant={chosenColumnToSort === 'overlap' ? 'unelevated' : 'outlined'}
				on:click={() => {
					handleSortButtonClick(2, 'overlap');
				}}
			>
				<Icon class="material-icons"
					><p class="number-myicon">
						{sort[2] === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up'}
					</p></Icon
				>
				Overlap
			</Button>
		</th>
		<th>
			<Button
				class="sort-button-number"
				variant={chosenColumnToSort === 'relevance' ? 'unelevated' : 'outlined'}
				on:click={() => {
					handleSortButtonClick(3, 'relevance');
				}}
			>
				<Icon class="material-icons"
					><p class="number-myicon">
						{sort[3] === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up'}
					</p></Icon
				>
				Relevance
			</Button>
		</th>
	</tr>
	{#each arrayOfVisibleDataWithFirstXElements as interestOverlap (interestOverlap.id)}
		<tr class="overlap-row">
			<td class="interest1-td" width="200">
				{interestOverlap.interest1}
			</td>
			<td class="interest2-td" width="200">
				{interestOverlap.interest2}
			</td>
			<td class="overlap-td" width="200">
				{interestOverlap.overlap}
			</td>
			<td class="relevance-td" width="200">
				{interestOverlap.relevance}
			</td>
		</tr>
	{/each}
	{#if arrayOfVisibleDataWithFirstXElements.length < arrayOfVisibleData.length}
		<tr class="show-next-row">
			<td colspan="4">
				<Button variant="raised" class="show-next-button" on:click={handlePaginating}>
					<Label>Load next {restToLoad.toLocaleString()} items</Label>
				</Button>
			</td>
		</tr>
	{/if}
</table>

<style>
	.th-interest {
		width: 300px;
	}

	.th-numbers {
		padding-right: 25px;
	}

	.interest-selector-th {
		display: flex;
		flex: 1;
		flex-direction: row;
		align-items: center;
		margin-bottom: 20px;
		padding-right: 20px;
	}

	.myicon {
		position: absolute;
		font-size: 37px;
		margin-top: -10px;
		margin-left: -2px;
	}

	.number-myicon {
		position: absolute;
		font-size: 37px;
		margin-top: -10px;
		margin-left: -8px;
	}

	* :global(.sort-button-interest) {
		height: 55px !important;
		width: 25px !important;
		margin-bottom: 1px !important;
	}

	* :global(.sort-button-number) {
		/*text-decoration: underline !important;*/
		height: 55px !important;
		margin-bottom: 20px !important;
	}

	table {
		border-spacing: 0;
		margin: auto;
		margin-top: 30px;
		table-layout: fixed;
	}

	td {
		border-bottom: 1px solid #999;
		/*border-right: 1px solid hsla(0, 0%, 100%, 0.67);*/
		font-size: 18px;
		padding-top: 7px;
		padding-bottom: 2px;
	}
	tr:nth-child(even) {
		background-color: #ececec;
	}

	.overlap-td {
		text-align: right;
		padding-right: 55px;
	}
	.relevance-td {
		text-align: right;
		padding-right: 35px;
	}

	.interest1-td {
		padding-left: 8px;
	}

	.interest2-td {
		text-align: right;
		padding-right: 38px;
	}

	.show-next-row {
		background-color: #f5f5f5 !important;
	}

	.show-next-row td {
		border-bottom: 0;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	:global(.show-next-button) {
		width: 250px !important;
		height: 50px !important;
	}
</style>
